module.exports = __webpack_public_path__ + "img/icon_calendar_2.26491dcd.svg";